




























import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    variant: { type: String, default: 'primary' },
    label: { type: String, default: null },
    icon: { type: Object as PropType<IconDefinition>, default: () => null },
    scrollContainer: {
      type: null,
      default: null
    },
    spaceFromBottom: { type: Number, default: 0.75 },
    id: { type: String, default: null },
    expandable: { type: Boolean, default: true },
    sticky: { type: Boolean, default: true },
    title: { type: String, default: null }
  },
  data() {
    return {
      lastScrollTop: 0,
      expanded: this.expandable,
      labelWidth: null
    }
  },
  watch: {
    label() {
      if (this.$refs.label) {
        this.labelWidth = `${this.$refs.label.scrollWidth + 50}px`
      }
    }
  },
  mounted() {
    this.getScrollContainer().addEventListener(
      'scroll',
      this.setLastScrollTop,
      { passive: true }
    )
    if (this.$refs.label) {
      this.labelWidth = `${this.$refs.label.scrollWidth + 50}px`
    }
  },

  beforeDestroy() {
    this.getScrollContainer().removeEventListener(
      'scroll',
      this.setLastScrollTop
    )
  },
  methods: {
    setLastScrollTop() {
      let beforeScrollTop = this.lastScrollTop
      const container = this.getScrollContainer()
      if (window instanceof container.constructor) {
        this.lastScrollTop =
          container.pageYOffset || document.documentElement.scrollTop
      } else {
        this.lastScrollTop = container.scrollTop
      }
      if (beforeScrollTop > this.lastScrollTop && this.expandable) {
        this.expanded = true
      } else {
        this.expanded = false
      }

      beforeScrollTop = this.lastScrollTop
    },
    getScrollContainer(): Element | Window {
      if (this.scrollContainer) {
        return this.scrollContainer
      }

      return window
    }
  }
})
